/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Expires_LabelInputs */

const en_admin_invite_codes_expires_label = /** @type {(inputs: Admin_Invite_Codes_Expires_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires at (optional)`)
};

const zh_admin_invite_codes_expires_label = /** @type {(inputs: Admin_Invite_Codes_Expires_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过期时间(可选)`)
};

/**
* | output |
* | --- |
* | "Expires at (optional)" |
*
* @param {Admin_Invite_Codes_Expires_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_expires_label = /** @type {((inputs?: Admin_Invite_Codes_Expires_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Expires_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_expires_label(inputs)
	return zh_admin_invite_codes_expires_label(inputs)
});
export { admin_invite_codes_expires_label as "admin.invite_codes.expires_label" }